<h2>Select a duration</h2>

<div class="flex justify-content-center">
  <div class="flex flex-column gap-1">
    @for (duration of durations; track duration.minutes) {
    <p-button [styleClass]="selectedDuration === duration.minutes ? 'selected' : 'select-btn'" (click)="onDurationClick(duration.minutes)">
      {{duration.minutes}} minutes
    </p-button>
    }
  </div>
</div>
<div class="flex justify-content-between mt-1 w-full">
  <p-button routerLink="../" label="BACK"></p-button>
  <p-button [routerLink]="['../', routes.SELECT_TIME]" [disabled]="!selectedDuration" label="NEXT"></p-button>
</div>